export enum StockInfoLocation {
  PDP = 'PDP',
  CartDrawerItem = 'CartDrawerItem',
  CartPageItem = 'CartPageItem',
  ProductListItem = 'ProductListItem',
  ProductCard = 'ProductCard',
  ProductCollectionItem = 'ProductCollectionItem',
}
